import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from './middleware/apiMiddleware';

// Fetch Dashboard Counts
export const fetchDashboardCounts = () => (dispatch) => {
    return dispatch(
        apiCallBegan({
            url: '/dashboard-counts',
            onStart: dashboardSlice.actions.countsRequested.type,
            onSuccess: dashboardSlice.actions.countsReceived.type,
            onError: dashboardSlice.actions.countsRequestFailed.type,
        })
    );
};

const initialState = {
    counts: {
        events: 0,
        venues: 0,
        contacts: 0,
        tickets: 0,
    },
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        countsRequested: (state) => {
            state.status = 'loading';
        },
        countsReceived: (state, action) => {
            state.status = 'succeeded';
            const data = action.payload?.data || action.payload;
            state.counts = {
                events: data.events || 0,
                venues: data.venues || 0,
                contacts: data.contacts || 0,
                tickets: data.tickets || 0,
            };
        },
        countsRequestFailed: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
    },
});

// Export selectors
export const selectDashboardCountsStatus = (state) => state.dashboard.status;

export const { countsRequested, countsReceived, countsRequestFailed } = dashboardSlice.actions;
export default dashboardSlice.reducer;
